import { createResource } from 'react-resource-router';

import { FeatureKeys } from '@atlassian/bitbucket-features';

import { setDeploymentDashboard } from 'src/components/pipelines/redux/actions/deployments';
import { getDeploymentDashboardUrl } from 'src/components/pipelines/redux/sagas/deployments';
import { ResourceContext } from 'src/router/types';

import { fetchData } from './utils';

export type Params = {
  repositoryFullSlug?: string;
  repositoryOwner?: string;
  repositorySlug?: string;
};

export const getUrl = (params: Params, url: string): string => {
  const fullSlug =
    params.repositoryFullSlug ||
    `${params.repositoryOwner}/${params.repositorySlug}`;

  return getDeploymentDashboardUrl(fullSlug, {
    includeHidden: url.includes('admin'),
  });
};

export const loadDeploymentDashboardResource = createResource({
  type: 'deployment-dashboard',
  getKey: ({ match: { params, url } }) => getUrl(params as Params, url),
  maxAge: 0,
  getData: async (
    { match: { params, url } },
    { reduxStore, appData }: ResourceContext
  ) => {
    if (!appData?.features[FeatureKeys.isPipelinesPageLoadOptimisationEnabled])
      return null;

    const { dispatch } = reduxStore;
    const data = await fetchData(
      getUrl(params as Params, url),
      'deployment_dashboard_resource_exception'
    );
    dispatch(setDeploymentDashboard(data));
    return { status: 'success' };
  },
});
